module.exports = __webpack_public_path__ + "components/flag/static/square/ar-5b5b4c08180a25a39ae8c8cbcb35c08f.svg";